import { styled } from '@mui/material/styles';
import { Stack, ToggleButtonGroup } from '@mui/material';

export const LoadingBox = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  height: 100px;
  gap: 8px;
`;

/**
 * Container principal do topo.
 * Controla a mudança de fluxo (coluna para linha) de forma responsiva via breakpoints.
 */
export const TopBarContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  gap: '16px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

/**
 * Agrupador do título e do botão de atualizar.
 */
export const TitleActionsWrapper = styled(Stack)`
  flex-direction: row;
  gap: 16px;
  align-items: center;
  width: 100%;
`;

/**
 * Container dos filtros/ações da direita.
 * Ajusta a largura dinamicamente para telas mobile.
 */
export const FilterActionsWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '8px',
  alignItems: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  },
}));

/**
 * Customização do grupo de botões para garantir dimensões fixas.
 */
export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  height: 36px;
  width: 100%;
`;

/**
 * Alinhamento interno do conteúdo do botão de atualizar.
 */
export const ButtonContentStack = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

/**
 * Alinhamento da barra de progresso com o texto de valor (RSSI).
 */
export const SignalProgressWrapper = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

